import * as checkoutGoal from './checkout.js';
import * as filtersGoal from './filters.js';
import * as contactGoal from './contact.js';
import * as interfaceGoal from './interface.js';
import * as productListGoal from './products-list.js';
import * as cartGoal from './cart.js';
import * as productGoal from './product.ts';
import * as fastDeliveryGoal from './fast-delivery.js';
import * as searchGoal from './search.ts';

export {
    checkoutGoal,
    filtersGoal,
    contactGoal,
    interfaceGoal,
    productListGoal,
    cartGoal,
    productGoal,
    fastDeliveryGoal,
    searchGoal,
};
